<template>
  <div class="dashboard-editor-container">

    <el-row
      type="flex"
      justify="space-between"
      style="background:#fff; padding:16px 0 0 0; margin-bottom:32px;"
    >
     <el-col :span="9" v-for="(item,index) in cardData" :key="index" style="padding: 0;">
        <CoreCard :cardInfo="item"/>
      </el-col>
    </el-row>


    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <LineChart
          :chart-data="{
            xAxis: this.barChartData1.xAxisData,
            series: [
              { name: '每日出库数量', data: this.barChartData1.seriesDataOne}
            ]
          }"
          :chart-info="{ title: '当月出库数量趋势图' }"
        />
      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
        <el-col :xs="24" :sm="24" :lg="24">
          <BarChart
          :chart-data="{
            xAxis: this.barChartData2.xAxisData,
            series: [
              { name: '发货数量', data: this.barChartData2.seriesDataOne}
            ],
            
          }"
          :chart-info="{ title: '当月发货产品数' }"
            />
        </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;" v-show="false">
      <el-col :xs="24" :sm="24" :lg="24">
        <LineChart
          :chart-data="{
            xAxis:this.lineChartx ,
            series: [
              { name: '平均发货时长', data:  this.actualNum  },
            ]
          }"
          :chart-info="{ title: '当月发货时长趋势图' }"
        />
      </el-col>
    </el-row>

    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <LineChart
          :chart-data="{
            xAxis: this.barChartData3.xAxisData,
            series: [
              { name: '扫码数量/实际发货数量%', data: this.barChartData3.seriesDataOne}
            ]
          }"
          :chart-info="{ title: '近30天发货扫码率趋势图' }"
        />
      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <OutOrderList />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import OutOrderList from "./outOrderList.vue";
import CoreCard  from"../components/CoreCard.vue";
import LineChart  from"../components/LineChart.vue";
import BarChart from '../components/BarChart.vue';
import { outBillCountCurDay,outBillProductCountCurDay,outBillAverageCount7Day,scanRateOfShipmentsCurDay,outBillCountCurMonth,outBillProductCountCurMonth,scanRateOfShipments30Day } from "@/api/board";
export default {
  name: "WarehouseLogistics",
  components: {
    CoreCard,
    LineChart,
    BarChart,
    OutOrderList
  },
  data() {
    return {
    cardData:[
          {
            titleOne:"当日出库订单数",
            numOne:0,
            titleTwo:"/商品数",
            numTwo:0,
            // ratioLabel:"完成率"
          },
          {
            titleOne:"近7天平均出库数量",
            numOne:0,
            marginTop:'0%'
          },
          // {
          //   titleOne:"平均扫码发货时长",
          //   numOne:0,
          //   marginTop:'0%'
          // },
          {
            titleOne:"出库扫码率",
            numOne:0,
            marginTop:'0%'
          },
      ],
      lineChartInfo:{
        title:"当月出库数量趋势图"
      },
      lineChartx:[],
      scanQrcodeNum:[],
      actualNum:[],
      barChartData1:{}, //当月出库数量趋势图
      barChartData2:{}, //当月发货产品数
      barChartData3:{}, //近30天发货扫码率趋势图
    };
  },


  mounted() {
    this.getOutBillCountCurDay();
    this.getOutBillProductCountCurDay();
    this.getOutBillAverageCount7Day();
    this.getScanRateOfShipmentsCurDay();
    this.getOutBillCountCurMonth();
    this.getOutBillProductCountCurMonth();
    this.getScanRateOfShipments30Day();
  },
  methods: {
    //获取今日产量
    getOutBillCountCurDay(){
     outBillCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numOne = response.data;
        }
      });
    },
        
    //获取今日计划产量
    getOutBillProductCountCurDay(){
     outBillProductCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numTwo = response.data;
        }
      });
    },
        
    //近7天平均出库数量
    getOutBillAverageCount7Day(){
     outBillAverageCount7Day().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[1].numOne = response.data;
        }
      });
    },

    //出库扫码率
    getScanRateOfShipmentsCurDay(){
     scanRateOfShipmentsCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[2].numOne = response.data + '%';
        }
      });
    },

    //当月出库数量趋势图
    getOutBillCountCurMonth(){
      outBillCountCurMonth().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          let chartData = {};
          chartData.xAxisData = [];
          chartData.seriesDataOne = []; 
          for (let i = 0; i < response.data.length; i++) {
            chartData.seriesDataOne.push(response.data[i].count);
            response.data[i].createDate = response.data[i].createDate.substring(0,response.data[i].createDate.length - 8);
            chartData.xAxisData.push(response.data[i].createDate);
          }
          this.barChartData1 = chartData;
        }
      });
    },

    //当月发货产品数
    getOutBillProductCountCurMonth(){
      outBillProductCountCurMonth().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          let chartData = {};
          chartData.xAxisData = [];
          chartData.seriesDataOne = []; 
          for (let i = 0; i < response.data.length; i++) {
            chartData.seriesDataOne.push(response.data[i].qty);
            chartData.xAxisData.push(response.data[i].cityCodeScan || response.data[i].provinceCodeScan);
          }
          this.barChartData2 = chartData;
        }
      });
    },

    //近30天发货扫码率趋势图: [扫码量/发货量]百分比
    getScanRateOfShipments30Day(){
      scanRateOfShipments30Day().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          let chartData = {};
          chartData.xAxisData = [];
          chartData.seriesDataOne = []; 
          for (let i = 0; i < response.data.length; i++) {
            chartData.seriesDataOne.push(response.data[i].rate);
            response.data[i].createDate = response.data[i].createDate.substring(0,response.data[i].createDate.length - 8);
            chartData.xAxisData.push(response.data[i].createDate);
          }
          this.barChartData3 = chartData;
        }
      });
    },


    


  },
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }
  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
